var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 2.25C17.3762 2.25 21.7502 6.62391 21.7502 12C21.7502 17.3761 17.3762 21.75 12.0002 21.75C6.62406 21.75 2.25015 17.3761 2.25015 12C2.25015 6.62391 6.62406 2.25 12.0002 2.25ZM11.0627 17.2458H12.9377V15.3708H11.0627V17.2458ZM11.2502 14.25H12.7502L13.0314 6.75H10.9689L11.2502 14.25Z",
    fill: "#6C01A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.8f18602c.svg";
export { ForwardRef as ReactComponent };